jQuery(document).ready(function ($) {
    $.fn.toggleHomeHeroBackground = function () {
        const active_tab = this.parent().find('.active');

        const active_tab_view = active_tab.attr('data-tab-view');
        const this_tab_view = this.attr('data-tab-view');

        const backgrounds = this.parent().parent().parent().prev();

        backgrounds.find(`.${active_tab_view}`).fadeOut(250);
        backgrounds.find(`.${this_tab_view}`).fadeIn(250);

        return this;
    }

    $('.home-hero__tab').on('click', function (event) {
        $(this).toggleHomeHeroBackground();
    });
});